import { serverHost } from "variables/serverdata";

function getAuthToken() {
    try {
        const raw = localStorage.getItem("user");
        if (!raw) return localStorage.getItem("token");
        const parsed = JSON.parse(raw);
        return (
            parsed?.access_token ||
            parsed?.token ||
            parsed?.accessToken ||
            null
        );
    } catch {
        return localStorage.getItem("token");
    }
}


export async function toggleDialplans(dialplans) {
    if (!Array.isArray(dialplans) || dialplans.length === 0) {
        throw new Error("dialplans must be a non-empty array");
    }

    const token = getAuthToken();
    if (!token) throw new Error("Missing auth token");

    const res = await fetch(`${serverHost}/toggle_dialplans`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ dp_uuids: dialplans }),
    });

    const data = await res.json();
    if (!res.ok) {
        throw new Error(data.error || "Failed to toggle dialplans");
    }

    return data;
}